<template>
  <div style="width:100%;margin: 20px 0;">
    <div class="doWhat_list">
      <div class="doWhat_item"
           @mouseenter="mouseover(index)"
           @mouseleave="mouseout"
           v-for="(item,index)  in list"
           :key="index">
        <span class="left">
          <div class="title">{{item.title}}</div>
          <div class="content">{{item.content}}</div>
          <div class="tagList">
            <div :class="activeIndex == index?'tagItems':'tagItem'"
                 v-for="(x,y) in item.list"
                 :key="'y'+y">
              {{x}}
            </div>
          </div>
        </span>
        <span class="right">
          <div class="bg"
               :class="activeIndex == index ?'activeImg':''"
               :style="{'backgroundImage':'url(' + $imgUrl+ item.bg + ')' ,'backgroundPosition':'100%','backgroundSize':'100% 100%' ,'backgroundRepeat': 'no-repeat'}"></div>
          <!-- :class="activeIndex == index ?'activeImg':''" -->
          <el-image style="width:100%;height:100%;position: absolute;left: 0;top: 0;padding: 20px;box-sizing: border-box;"
                    :src="$imgUrl+item.img"
                    alt=""></el-image>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    mouseover (index) {
      this.activeIndex = index;
    },
    mouseout () {
      this.activeIndex = -1;
    }
  },
  data () {
    return {
      activeIndex: -1,
      list: [
        {
          title: '业绩增长系统',
          content: "满足业务管理部门与业务要求，打造连锁化经营和业绩提升计划，并通过月度经营计划，参与经营目标达成。",
          list: ['生鲜体系', '营运体系', '采购体系', '营销体系'],
          img: 'home/001/经营01_1.png',
          bg: 'home/001/经营01.png'
        },
        {
          title: '组织创新系统',
          content: "建立总部管控体系，设计组织架构，规范责权体系和核心管理，成功实现总部对各 业务单元的立体化服务。",
          list: ['中基层执行力', '中高层管理力', '高层领导力'],
          img: 'home/001/管理01_1.png',
          bg: 'home/001/管理01.png'
        },
        {
          title: '财法税系统',
          content: "掌握各项法律法规，利用好政策措施，避开经营风险，有效预决算管理，让经营更安全，实现正规化持续化盈利！",
          list: ['税务筹划', '资本运作', '预算管理'],
          img: 'home/001/财税01_1.png',
          bg: 'home/001/财税01.png'
        },
        {
          title: '战略引擎系统',
          content: "解决企业战略迷茫问题，重构商业模式，找寻新盈利增长点，清晰战略发展，帮助老板在新商业时代成为企业家、教育家、投资家...",
          list: ['商业模式', '盈利模式', '投资融资'],
          img: 'home/001/战略01_1.png',
          bg: 'home/001/战略01.png'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.doWhat_list {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  .doWhat_item {
    display: inline-block;
    width: 48.5%;
    cursor: pointer;
    margin-right: 3%;
    margin-bottom: 40px;
    height: 260px;
    // background-color: #fff;
    background: url('../../assets/home/FL_BJ_MR.png') 100% 100% no-repeat;
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    padding: 30px 230px 30px 30px;
    .left {
      .title {
        font-size: 28px;
        font-weight: bold;
      }
      .content {
        font-size: 14px;
        margin-top: 20px;
        margin-right: 40px;
      }
      .tagList {
        display: flex;
        margin-top: 50px;
        .tagItem {
          padding: 5px 10px;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
          margin-right: 8px;
          font-size: 12px;
          color: #999;
        }
        .tagItems {
          padding: 5px 10px;
          border: 1px solid #de1f26;
          border-radius: 6px;
          margin-right: 8px;
          font-size: 12px;
          color: #de1f26;
        }
      }
    }
    .activeImg {
      -webkit-transform: rotate(360deg);

      animation: rotation 8s linear infinite;

      -moz-animation: rotation 8s linear infinite;

      -webkit-animation: rotation 8s linear infinite;

      -o-animation: rotation 8s linear infinite;
    }
    @-webkit-keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
      }

      to {
        -webkit-transform: rotate(360deg);
      }
    }
    .right {
      position: absolute;
      right: 40px;
      top: 40px;
      width: 188px;
      height: 188px;
      padding: 20px;
      box-sizing: border-box;
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      // .an {
      //   -webkit-transform: rotate(360deg);

      //   animation: rotation 3s linear infinite;

      //   -moz-animation: rotation 3s linear infinite;

      //   -webkit-animation: rotation 3s linear infinite;

      //   -o-animation: rotation 3s linear infinite;
      // }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .doWhat_item:hover {
    background: url('../../assets/home/FL_BJ_xz.png') 100% 100% no-repeat;
    color: #de1f26;
  }
  .doWhat_item:nth-child(2) {
    margin-right: 0;
  }
  .doWhat_item:nth-child(4) {
    margin-right: 0;
  }
}
</style>